import { render, staticRenderFns } from "./AppTextFieldV2.vue?vue&type=template&id=2d511718&scoped=true&"
import script from "./AppTextFieldV2.vue?vue&type=script&lang=js&"
export * from "./AppTextFieldV2.vue?vue&type=script&lang=js&"
import style0 from "./AppTextFieldV2.vue?vue&type=style&index=0&id=2d511718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d511718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
